import { render, staticRenderFns } from "./register-type.vue?vue&type=template&id=5a8fc880&"
import script from "./register-type.vue?vue&type=script&lang=js&"
export * from "./register-type.vue?vue&type=script&lang=js&"
import style0 from "./register-type.vue?vue&type=style&index=0&id=5a8fc880&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports